import { Component, input } from '@angular/core';
import { ResponsiveVisibility } from '../../responsive-visibility';

@Component({
    selector: 'pdf-editor',
    templateUrl: './pdf-editor.component.html',
    styleUrls: ['./pdf-editor.component.css'],
    standalone: false
})
export class PdfEditorComponent {
  public showCommentEditor = input<ResponsiveVisibility>(true);

  public showDrawEditor = input<ResponsiveVisibility>(true);

  public showHighlightEditor = input<ResponsiveVisibility>(true);

  public showTextEditor = input<ResponsiveVisibility>(true);

  public showSignatureEditor = input<ResponsiveVisibility>(true);

  public showStampEditor = input<ResponsiveVisibility>(true);

  // stephanrauh/pdf.js#14 modified by ngx-extended-pdf-viewer - the eraser
  public showEraserEditor = input<ResponsiveVisibility>(false);

  public disableEraserEditor = input<boolean>(false);
  // stephanrauh/pdf.js#14 end of modification by ngx-extended-pdf-viewer

  // #3257 modified by ngx-extended-pdf-viewer
  public showSignaturePropertiesButton = input<ResponsiveVisibility>(true);
  // #3257 end of modification by ngx-extended-pdf-viewer

  // #2818 modified by ngx-extended-pdf-viewer
  public disableCommentEditor = input<boolean>(false);
  public disableDrawEditor = input<boolean>(false);
  public disableHighlightEditor = input<boolean>(false);
  public disableTextEditor = input<boolean>(false);
  public disableSignatureEditor = input<boolean>(false);
  public disableStampEditor = input<boolean>(false);
  // #2818 end of modification by ngx-extended-pdf-viewer
}
